const syrapayHostedFormStyle = { hidden: { visibility: 'hidden', pointerEvents: 'none' } };

export default syrapayHostedFormStyle;
